import restClient from ".";
import { WS_TOKEN } from "../constants/api-url";
import { getJwtToken } from './refreshToken';

async function exchangeWsToken(): Promise<string | null> {
    const jwt = await getJwtToken();
    if (!jwt) {
        return null;
    }
    const { data } = await restClient.post(WS_TOKEN, null, { params: { token: jwt } });
    return data.token;
}

export default exchangeWsToken;
